

















import Vue from "vue";

export default Vue.extend({
  props: {
    selected: Object,
    active: Boolean,
  },
});
